/**
 * @generated SignedSource<<8eedbb5531cb49eb7c764c0561900deb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useWalletConnectionEnsured_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"usePersistedWalletAddress_viewer">;
  readonly " $fragmentType": "useWalletConnectionEnsured_viewer";
};
export type useWalletConnectionEnsured_viewer$key = {
  readonly " $data"?: useWalletConnectionEnsured_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useWalletConnectionEnsured_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useWalletConnectionEnsured_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchUser",
          "variableName": "fetchUser"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "usePersistedWalletAddress_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "de86ac473d0afb39c2b6baf2e60d6c7c";

export default node;
